/**
 * Created by smizrahi on 8/1/16.
 */

import EQError from "../utils/EQError";

/*eslint-disable no-undef*/
export default class WebService {
    constructor() {

    }

    /**
     * Execute a POST query
     *
     * @param url
     * @param parameters with key / value
     * @returns {Promise}
     */
    post(url, parameters) {
        return new Promise((resolve, reject) => {
            let parametersQueryArray = [];

            for (let key in parameters) {
                parametersQueryArray.push(key + '=' + encodeURIComponent(parameters[key]));
            }

            let parametersQuery = parametersQueryArray.join('&');

            let req = new XMLHttpRequest();
            req.open('POST', url, true);
            req.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');

            req.onload = function () {
                if (req.status == 200) {
                    let response = req.responseText;
                    resolve(response);
                } else {
                    if (req.status == 500) {
                        // Try to parse XML response
                        var parseString = require('xml2js').parseString;
                        parseString(req.responseText, {
                            attrkey: 'attr',
                            childkey: 'child',
                            charkey: 'val'
                        }, function (err, result) {
                            if (err) {
                                reject(new EQError(req.statusText, req.status, true));
                            } else {
                                reject(new EQError(result.response.error[0].attr.message, parseInt(result.response.error[0].attr.code), false));
                            }
                        });
                    } else {
                        reject(new EQError(req.statusText, req.status, true));
                    }
                }


            };
            req.onerror = function () {
                reject(new EQError('Network Error', 1200, true));
            };
            req.send(parametersQuery);
        });
    }

    /**
     * Execute a GET query
     *
     * @param url
     * @param parameters a map key/value
     * @returns {Promise}
     */
    get(url, parameters = null) {
        return new Promise((resolve, reject) => {
            let parametersQuery = null;
            if (parameters) {
                let parametersQueryArray = [];

                parameters.forEach((value, key) => {
                    parametersQueryArray.push(key + '=' + encodeURIComponent(parameters[key]))
                });

                parametersQuery = parametersQueryArray.join('&');
            }
            let req = new XMLHttpRequest();
            if (parametersQuery) {
                req.open('GET', url + '?' + parametersQuery, true);
            } else {
                req.open('GET', url, true);
            }

            req.onload = function () {
                if (req.status == 200) {
                    let response = req.responseText;
                    resolve(response);
                } else {
                    reject(new EQError(req.statusText, req.status, true));
                }
            };
            req.onerror = function () {
                reject(new EQError('Network Error', 1200, true));
            };
            req.send(parametersQuery);
        });
    }

    /**
     * Execute a POST query
     *
     * @param {string} url
     * @param {string} raw data to post
     * @returns {Promise}
     */
    postRaw(url, raw) {
        return new Promise((resolve, reject) => {
            let req = new XMLHttpRequest();
            req.open('POST', url, true);
            req.onload = function () {
                if (req.status == 200) {
                    let response = req.responseText;
                    resolve(response);
                } else {
                    if (req.status == 500) {
                        reject(new EQError(req.statusText, req.status, true));
                    } else {
                        reject(new EQError(req.statusText, req.status, true));
                    }
                }
            };
            req.onabort = function () {
                reject(new EQError('Network Error', 1201, true));
            };
            req.onerror = function () {
                reject(new EQError('Network Error', 1200, true));
            };
            req.send(raw);
        });
    }
}



// WEBPACK FOOTER //
// ./js/core/services/WebService.js